import React from "react"
import parentStyles from "../styles.css"
import styles from "./styles.css"
import PropTypes from "prop-types"
import { handlePhone } from "services/utils/mask"

const InputPhone = ({ formik, formValues }) => {
  const { name, placeholder } = formValues
  const { setFieldValue, touched, values, errors, handleBlur } = formik
  const isErrorField = touched[name] && errors[name]

  const handleChange = (name, value) => {
    setFieldValue(name, value, true)

    const updatedErrors = { ...errors }
    if (updatedErrors[name]) {
      delete updatedErrors[name]
      formik.setErrors(updatedErrors)
    }
  }

  const handleInputPhone = (e) => {
    const { name, formattedValue } = handlePhone(e)
    handleChange(name, formattedValue)
  }

  return (
    <div className={parentStyles.line}>
      <div className={styles.input_field}>
        <input
          id={name}
          name={name}
          type="tel"
          placeholder={placeholder}
          className={`${isErrorField && parentStyles.focus_error}`}
          onChange={(e) => {
            handleInputPhone(e)
          }}
          value={values[name]}
          onBlur={handleBlur}
        />
        {isErrorField && (
          <div className={parentStyles.error}>{errors[name]}</div>
        )}
      </div>
    </div>
  )
}

InputPhone.propTypes = {
  formik: PropTypes.object,
  formValues: PropTypes.object.isRequired
}

export default InputPhone



// WEBPACK FOOTER //
// ./src/scenes/FixedVoice/components/Inputs/InputPhone/index.js